export default {
  showLoader: function (show) {
    if (!$("#mr-loading-overlay")) return;

    if (show) $("#mr-loading-overlay").css("display", "inline");
    else $("#mr-loading-overlay").css("display", "none");
  },
};
